
export default function saveFile(name, type, data) {
  if (data !== null && navigator.msSaveBlob) {
    return navigator.msSaveBlob(new Blob([data], { type }), name)
  }
  let tagA = document.createElement('a');
  tagA.style.cssText = 'display: none'
  let url = window.URL.createObjectURL(new Blob([data], { type }));
  tagA.href = url;
  tagA.download = name;
  document.body.appendChild(tagA);
  tagA.click();
  window.URL.revokeObjectURL(url);
  tagA.remove();
}
